/* eslint-disable no-redeclare */
import { z } from 'zod';

export const MaritalStatus = z.enum([
  'SINGLE',
  'MARRIED',
  'WIDOWED',
  'SEPARATED',
  'DIVORCED',
]);

export type MaritalStatus = z.infer<typeof MaritalStatus>;
